import React from "react";
import { useNavigate } from "react-router-dom";
import { Button, Form, Schema } from "rsuite";
import { useRegisterUserMutation } from "../../entities/User/userApi";
import { formClass } from "../../shared/helpers";
import "./RegisterPage.scss";
import type { RegisterUserRequest } from "../../entities/User/types/userType";
import { Logo } from "../../shared/components/Logo/Logo";

const { StringType } = Schema.Types;

const model = Schema.Model({
	firstName: StringType().isRequired("This field is required."),
	lastName: StringType().isRequired("This field is required."),
	email: StringType()
		.isEmail("Please enter a valid email address.")
		.isRequired("This field is required."),
	password: StringType().isRequired("This field is required."),
});

export const RegisterPage = () => {
	const navigate = useNavigate();
	const [registerUser] = useRegisterUserMutation();
	const [formValue, setFormValue] = React.useState({
		firstName: "",
		lastName: "",
		email: "",
		password: "",
	});
	const [formError, setFormError] = React.useState({});

	const handleSubmit = async () => {
		if (
			!formValue.firstName ||
			!formValue.lastName ||
			!formValue.email ||
			!formValue.password
		) {
			setFormError({
				firstName: formValue.firstName ? "" : "This field is required.",
				lastName: formValue.lastName ? "" : "This field is required.",
				email: formValue.email ? "" : "This field is required.",
				password: formValue.password ? "" : "This field is required.",
			});
			return;
		}

		try {
			const result = await registerUser(formValue).unwrap();
			if (result && result?.status === "success") {
				navigate("/login");
			}
		} catch (error) {
			console.error("Failed to register user:", error);
		}
	};

	const handleFormChange = (formValue: Record<string, string>) => {
		setFormValue(formValue as unknown as RegisterUserRequest);
	};

	return (
		<div className={formClass("register")}>
			<Logo />
			<Form
				model={model}
				formValue={formValue}
				formError={formError}
				onChange={handleFormChange}
				onSubmit={handleSubmit}
			>
				<Form.Group>
					<Form.ControlLabel>First Name</Form.ControlLabel>
					<Form.Control name="firstName" />
				</Form.Group>
				<Form.Group>
					<Form.ControlLabel>Last Name</Form.ControlLabel>
					<Form.Control name="lastName" />
				</Form.Group>
				<Form.Group>
					<Form.ControlLabel>Email</Form.ControlLabel>
					<Form.Control name="email" type="email" />
				</Form.Group>
				<Form.Group>
					<Form.ControlLabel>Password</Form.ControlLabel>
					<Form.Control name="password" type="password" />
				</Form.Group>
				<Form.Group>
					<Button appearance="primary" type="submit">
						Register
					</Button>
				</Form.Group>
			</Form>
		</div>
	);
};
